import React from 'react'
import { Route, IndexRoute  } from 'react-router'

// Components
import App from '../containers/App'
import MenuLandings from '../containers/Sections/Menu'
import MenuSearch from '../containers/Sections/Menu/SearchMenu'
import Home from '../features/PageHome/PageHome.container'
import Residencial from '../features/PageResidential/PageResidential.container'
import Oficinas from '../features/PageOffices/PageOffices.container'
import Locales from '../features/PageRetail/PageRetail.container'
import Industrias from '../features/PageIndustries/PageIndustries.container'
import Hoteles from '../features/PageHotels/PageHotels.container'
import Campos from '../features/PageFarms/PageFarms.container'
import Emprendimientos from '../features/PageEntrepreneurship/PageEntrepreneurship.container'
import EmprendimientoDetail from '../features/PageEntrepreneurship/components/Detail'
import Terrenos from '../features/PageLands/PageLands.container'
import Tasaciones from '../features/PageAppraisals/PageAppraisals.container'
import Empresa from '../features/PageCompany/PageCompany.container'
import Propiedades from '../containers/Sections/Propiedades'
import PropiedadDetail from '../containers/Sections/Propiedades/detail'
import Barrio from '../features/PageNeighborhoods/components/NeighborhoodView/PageNeighborhoodView.container'
import NeighborhoodList from '../features/PageNeighborhoods/PageNeighborhoods.container'
import Sucursal from '../features/PageBranches/PageBranches.container'
import Imi from '../containers/Sections/Imi'
import Notes from '../containers/Sections/Imi/notes'
import NewsletterNotes from '../containers/Sections/Newsletter/notes'
import ImiDetail from '../containers/Sections/Imi/detail'
import NewsletterDetail from '../containers/Sections/Newsletter/detail'
import Newsletter from '../containers/Sections/Newsletter'
import News from '../containers/Sections/News'
import FooterLargo from '../features/commons/Footer/FooterLarge.container'
import NoMatch from '../components/NoMatch'
import PageConsultancyAndResearch from '../features/PageConsultancyAndResearch/PageConsultancyAndResearch.container'
import PageServices from '../features/PageServices/PageServices.container'

export default (
  <Route path='/' component={App}>
    <IndexRoute components={{main: Home, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/residencial' components={{main: Residencial, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/oficinas' components={{main: Oficinas, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/locales' components={{main: Locales, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/industrias' components={{main: Industrias, menu: MenuLandings, footer: FooterLargo}} />
    {/* HIDE-HOTELS <Route path='/hoteles' components={{main: Hoteles, menu: MenuLandings, footer: FooterLargo}} /> */}
    <Route path='/campos' components={{main: Campos, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/emprendimientos' components={{main: Emprendimientos, menu: MenuLandings, footer: FooterLargo}} />
    <Route
      path='/emprendimientos/:id' components={{main: EmprendimientoDetail, menu: MenuLandings, footer: FooterLargo}}
    />
    <Route path='/terrenos' components={{main: Terrenos, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/tasaciones' components={{main: Tasaciones, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/empresa' components={{main: Empresa, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/servicios' components={{main: PageServices, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/propiedades' components={{main: Propiedades, menu: MenuSearch, footer: FooterLargo}} />
    <Route
      path='/informes-del-mercado-inmobiliario' components={{main: Imi, menu: MenuLandings, footer: FooterLargo}}
    />
    <Route
      path='/informes-del-mercado-inmobiliario/:id' components={{main: Notes, menu: MenuLandings, footer: FooterLargo}}
    />
    <Route path='/note-imi/:id' components={{main: ImiDetail, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/note-newsletter/:id' components={{main: NewsletterDetail, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/newsletters' components={{main: Newsletter, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/newsletters/:id' components={{main: NewsletterNotes, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/noticias' components={{main: News, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/barrios' components={{main: NeighborhoodList, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/barrios/:id' components={{main: Barrio, menu: MenuLandings, footer: FooterLargo}} />
    <Route path='/sucursal/:name' components={{main: Sucursal, menu: MenuLandings, footer: FooterLargo}} />
    <Route
      path='/consultancy-research'
      components={{main: PageConsultancyAndResearch, menu: MenuLandings, footer: FooterLargo}}
    />
    <Route path='/:id' components={{main: PropiedadDetail, footer: FooterLargo}} />
    <Route path='*' exact components={{main: NoMatch, footer: FooterLargo}} />
  </Route>
)



// WEBPACK FOOTER //
// ./src/routes/routes.js